import {view, Icon} from '@sail/ui';
import {warningCircle} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';

const messages = defineMessages({
  succeeded: {
    id: 'conversations_ui.link_status_badge.success',
    description: 'Label for the platform link',
    defaultMessage: 'Success',
  },
  failed: {
    id: 'conversations_ui.link_status_badge.failed',
    description: 'Label for the failed transaction',
    defaultMessage: 'Failed',
  },
  refunded: {
    id: 'conversations_ui.link_status_badge.refunded',
    description: 'Label for refunded transaction',
    defaultMessage: 'Refunded',
  },
  pending: {
    id: 'conversations_ui.link_status_badge.pending',
    description: 'Label for the pending tarnsaction',
    defaultMessage: 'Pending',
  },
});

const statusColor: Record<string, string> = {
  succeeded: '#006635',
  failed: '#C0123C',
  refunded: '#C0123C',
  pending: '#CC4B00',
};

export type StatusType = 'succeeded' | 'failed' | 'refunded' | 'pending';

export const StatusBadge = ({status}: {status: StatusType}) => {
  const intl = useIntl();
  const statusMessages: Record<string, string> = {
    succeeded: intl.formatMessage(messages.succeeded),
    failed: intl.formatMessage(messages.failed),
    refunded: intl.formatMessage(messages.refunded),
    pending: intl.formatMessage(messages.pending),
  };
  const message = statusMessages[status];
  const showWarningIcon = status === 'failed' || status === 'refunded';
  return (
    <view.div
      css={{
        baseline: 'x-middle',
        borderRadius: 'medium',
        display: 'inline',
        font: 'label.small.emphasized',
        gap: 'xsmall',
        padding: 'xsmall',
        stack: 'x',
        whiteSpace: 'nowrap',
        backgroundColor: '#F5F5F5',
        border: '1px ',
        color: statusColor[status],
      }}
    >
      {showWarningIcon ? (
        <Icon data-testid="warning-icon" icon={warningCircle} size="xsmall" />
      ) : null}
      {message}
    </view.div>
  );
};
